import { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { MeshDistortMaterial } from '@react-three/drei'
import { easing } from 'maath'
import * as THREE from 'three'

const SPHERE_RADIUS = 1.2

function SphereEdgeLed() {
  const edgeRef = useRef()
  const bloomRef = useRef()

  useFrame(({ clock }) => {
    const pulse = 0.8 + Math.sin(clock.getElapsedTime() * 2.4) * 0.2
    edgeRef.current.material.opacity = 0.92 * pulse
    bloomRef.current.material.opacity = 0.28 * pulse
  })

  return (
    <>
      <mesh ref={bloomRef} scale={1.028}>
        <sphereGeometry args={[SPHERE_RADIUS, 64, 64]} />
        <meshBasicMaterial
          color="#8b6cff"
          transparent
          opacity={0.28}
          side={THREE.BackSide}
          toneMapped={false}
          blending={THREE.AdditiveBlending}
          depthWrite={false}
        />
      </mesh>
      <mesh ref={edgeRef} scale={1.01}>
        <sphereGeometry args={[SPHERE_RADIUS, 64, 64]} />
        <meshBasicMaterial color="#e8e0ff" transparent opacity={0.92} side={THREE.BackSide} toneMapped={false} />
      </mesh>
    </>
  )
}

function EsferaAnimada() {
  const groupRef = useRef()
  const eyesRef = useRef()

  useFrame((state, delta) => {
    const { x, y } = state.pointer
    const floatY = Math.sin(state.clock.getElapsedTime() * 2) * 0.1

    easing.damp3(groupRef.current.position, [x * 0.5, y * 0.5 + floatY, 0], 0.2, delta)
    easing.dampE(eyesRef.current.rotation, [-y * 0.6, x * 0.6, 0], 0.15, delta)
  })

  return (
    <group ref={groupRef}>
      <group scale={0.68}>
        <ambientLight intensity={0.4} />
        <pointLight position={[5, 5, 5]} intensity={1.5} color="#4c00ff" />
        <pointLight position={[-5, -5, -5]} intensity={1} color="#00ffaa" />
        <directionalLight position={[0, 5, 2]} intensity={1} />

        <SphereEdgeLed />

        <mesh>
          <sphereGeometry args={[SPHERE_RADIUS, 64, 64]} />
          <MeshDistortMaterial
            color="#3b3b7a"
            roughness={0.1}
            metalness={0.1}
            clearcoat={1}
            clearcoatRoughness={0.1}
            transmission={0.55}
            thickness={1.5}
            speed={2}
            distort={0.15}
            emissive="#5a4acc"
            emissiveIntensity={0.12}
          />
        </mesh>

        <group ref={eyesRef}>
          <mesh position={[-0.25, 0, 1.15]}>
            <capsuleGeometry args={[0.06, 0.2, 4, 16]} />
            <meshBasicMaterial color="#ffffff" toneMapped={false} />
          </mesh>
          <mesh position={[0.25, 0, 1.15]}>
            <capsuleGeometry args={[0.06, 0.2, 4, 16]} />
            <meshBasicMaterial color="#ffffff" toneMapped={false} />
          </mesh>
        </group>
      </group>
    </group>
  )
}

export default function EyeSphereOverlay({ eventSource }) {
  return (
    <div className="eye-sphere-layer">
      <Canvas
        dpr={[1, 1.5]}
        camera={{ position: [0, 0, 5], fov: 45 }}
        gl={{ alpha: true, antialias: true }}
        onCreated={({ gl }) => gl.setClearColor(0x000000, 0)}
        eventSource={eventSource}
        eventPrefix="client"
      >
        <EsferaAnimada />
      </Canvas>
    </div>
  )
}
